/* Categories */
const routes = [
  /* Document Management */
  {
    url: 'document',
    title: 'Document Management',
    subtitle: 'Non-distribution, cold chain or label item',
    category: '/document',
    prev: 'Categories', prevStep: 'guide',
    products: [
      {
        id: 101,
        name: 'Custom Cut Sheet',
        image: 'document/note.svg',
        tips: 'Custom cut sheet category.'
      },
      {
        id: 102,
        name: 'Multi Sheeted Product',
        image: 'document/paper.svg',
        tips: 'Multi-part sheeted product category.'
      },
      {
        id: 103,
        name: 'Custom Roll Product',
        image: 'document/custom-roll.svg',
        tips: 'Custom roll product category.'
      },
      {
        id: 104,
        name: 'Custom Continuous',
        image: 'document/paper-roll.svg',
        tips: 'Custom continuous category.'
      },
      {
        id: 105,
        name: 'Kit',
        image: 'document/briefcase.svg',
        tips: 'Kit product category.' },
      {
        id: 106,
        name: 'Mail Merge',
        image: 'document/message.svg',
        tips: 'Cost for file upload and address creation.'
      },
      {
        id: 107,
        name: 'Product Other',
        image: 'document/box.svg',
        tips: 'Items that do not fit a traditional form/marketing collateral category.'
      }
    ]
  },
  /* Custom Cut Sheet */
  {
    url: 'document/pid-101',
    title: 'Custom Cut Sheet',
    subtitle: 'Custom cut sheet category.',
    category: '/document',
    prev: 'Document Management', prevStep: 'document',
    products: [
      {
        id: 109,
        name: 'POD Facility',
        image: 'document/factory.svg',
        tips: 'Small-run jobs utilizing large-format and/or high-volume laser or Inkjet printers.'
      },
      {
        id: 110,
        name: 'Non POD Facility',
        image: 'document/facilities.svg',
        tips: 'Printed on a Press, High Volume Run.'
      }
    ]
  },
  /* Multi Sheeted Product */
  {
    url: 'document/pid-102',
    title: 'Multi Sheeted Product',
    subtitle: 'Multi-part sheeted product category.',
    category: '/document',
    prev: 'Document Management', prevStep: 'document',
    products: [
      {
        id: 111,
        name: 'Unit/Set/ZipSet',
        image: 'document/envelope.svg',
        tips: 'Multiple ply forms, delivered into a single set - packaged in a carton.'
      },
      {
        id: 112,
        name: 'Mailer',
        image: 'document/email.svg',
        tips: 'Mailer product category.'
      },
      {
        id: 113,
        name: 'Form Label',
        image: 'document/product-development.svg',
        tips: 'Multiple ply forms with a label attached to the form, delivered into a single set - packaged in a carton.'
      }
    ]
  },
  /* Custom Roll Product */
  {
    url: 'document/pid-103',
    title: 'Custom Roll Product',
    subtitle: 'Custom roll product category.',
    category: '/document',
    prev: 'Document Management', prevStep: 'document',
    products: [
      {
        id: 114,
        name: 'Continuous Roll',
        image: 'document/paper-rolls.svg',
        tips: 'Forms delivered in a roll to the customer, typically 40 - 50 inches in diameter.'
      },
      {
        id: 115,
        name: 'Secure Document',
        image: 'document/documents.svg',
        tips: 'Roll Form with security features (Checks)'
      },
      {
        id: 116,
        name: 'Pressure Seal',
        image: 'document/stamp.svg',
        tips: 'Forms delivered in a roll with glue. Customer converts into a mailer.'
      },
      {
        id: 117,
        name: 'High Color',
        image: 'document/colors.svg',
        tips: 'Forms delivered in a roll to the customer with more than 6 ink colors.'
      }
    ]
  },
  /* Custom Continuous */
  {
    url: 'document/pid-104',
    title: 'Custom Continuous',
    subtitle: 'Custom continuous category.',
    category: '/document',
    prev: 'Document Management', prevStep: 'document',
    products: [
      { id: 118,
        name: 'Single Fanfold',
        image: 'document/custom-continuous/folder-single.svg',
        tips: 'Continuous Forms with pin feed on 2 sides, 1 ply fan folded and packaged in cartons.'
      },
      {
        id: 119,
        name: 'Multiply Fanfold',
        image: 'document/custom-continuous/folder.svg',
        tips: 'Continuous Forms with pin feed on 2 sides, multiple ply fan folded and packaged in cartons.'
      },
      { id: 120,
        name: 'Form/Label Affixed',
        image: 'document/custom-continuous/report.svg',
        tips: 'Continuous forms with pin feed - Label affixed - Piggy Back label with liner attached to sheet, fanfold into cartons.'
      },
      {
        id: 121,
        name: 'Form/Label Integrated',
        image: 'document/custom-continuous/appraisal-form.svg',
        tips: 'Continuous form with die cut, adhesive, liner added to the product to create label, fanfolded into cartons.'
      },
      {
        id: 122,
        name: 'Form/Label Combo',
        image: 'document/custom-continuous/documentation.svg',
        tips: 'Continuous form with part of the form being paper product and the other half being a label product, fanfolded and packed into a carton.'
      },
      {
        id: 123,
        name: 'High Color',
        image: 'document/custom-continuous/brush.svg',
        tips: 'Continuous form with more than 6 ink colors, fanfolded and packaged into a carton.'
      }
    ]
  },
  /* Kit */
  {
    url: 'document/pid-105',
    title: 'Kit',
    subtitle: 'Kit product category.',
    category: '/document',
    prev: 'Document Management', prevStep: 'document',
    products: [
      {
        id: 124,
        name: 'Kitted Products Components',
        image: 'document/kit/data.svg',
        tips: 'Items purchased for a kit, not produced internally.'
      },
      {
        id: 125,
        name: 'Kit Summary',
        image: 'document/kit/presentation.svg',
        tips: 'Preassembled Kit'
      }
    ]
  },
  /* Product Other */
  {
    url: 'document/pid-107',
    title: 'Product Other',
    subtitle: 'Items that do not fit a traditional form/marketing collateral category',
    category: '/document',
    prev: 'Document Management', prevStep: 'document',
    products: [
      {
        id: 126,
        name: 'ATM Rolls/Small Rolls',
        image: 'document/other/atm.svg',
        tips: 'Small Rolls used in ATM or Cash.'
      },
      {
        id: 127,
        name: 'Mill Direct-Roll-50',
        image: 'document/other/paper-roll.svg',
        tips: '50 inch rolls of paper received direct from the paper mill. Blank Paper.'
      },
      {
        id: 128,
        name: 'Mill Direct',
        image: 'document/other/paper-roll-outline-variant.svg',
        tips: 'Cut Sheet Paper received direct from the mill in cut sheets.'
      },
      {
        id: 129,
        name: 'Non-Paper Non Label Products',
        image: 'document/other/touch.svg',
        tips: 'Product we cannot make internally (Blinders, Coolers, ice packs).'
      },
      {
        id: 130,
        name: 'Envelopes',
        image: 'document/other/mail-inbox-app.svg',
        tips: 'Envelopes product category.'
      },
      {
        id: 131,
        name: 'Plastic Cards',
        image: 'document/other/debit-card.svg',
        tips: 'Membership cards, no monetary value.'
      },
      {
        id: 132,
        name: 'Gift Cards/Monetary',
        image: 'document/other/gift-card.svg',
        tips: 'Gift Card with monetary value.'
      },
      {
        id: 133,
        name: 'Bags',
        image: 'document/other/bag.svg',
        tips: 'Paper, plastic, fabric bags.'
      },
      {
        id: 134,
        name: 'Mount Sheets',
        image: 'document/other/sticky-note.svg',
        tips: 'Single ply cut sheet with multiple strips of tape cardiology forms.'
      },
      {
        id: 135,
        name: 'Peg Boards and Forms',
        image: 'document/other/strategy.svg',
        tips: 'Forms that are used in Dr. offices that are applied to a peg binder.'
      },
      {
        id: 136,
        name: 'Post It Notes',
        image: 'document/other/post-it.svg',
        tips: 'Post it Notes category.'
      },
      {
        id: 137,
        name: 'Zip Mailer/Data Mailer',
        image: 'document/other/zip.svg',
        tips: 'Multiply form.'
      }
    ]
  },
  /* Marketing Collateral */
  {
    url: 'document/pid-108',
    title: 'Marketing Collateral',
    subtitle: 'Non Digital larger quantities runs.',
    category: '/document',
    prev: 'Document Management', prevStep: 'document',
    products: [
      {
        id: 138,
        name: 'Book/Booklet',
        image: 'document/marketing/brochure.svg',
        tips: 'Books, Perfect Bound, Coil, Tape, Binding, Saddle Stitch - Min Qty 2500. Potientially Outsourced.'
      },
      {
        id: 139,
        name: 'Brochure/Flyer',
        image: 'document/marketing/flyers.svg',
        tips: 'Larger Qty Printed Color Toner, more than 10000.'
      },
      {
        id: 140,
        name: 'Card/Postcard',
        image: 'document/marketing/postcard.svg',
        tips: 'Larger Qty Printed Color Toner, more than 10000.'
      },
      {
        id: 141,
        name: 'Patient Communication Boards',
        image: 'document/marketing/medical-records.svg',
        tips: 'Patient communication boards category.'
      },
      {
        id: 142,
        name: 'Presentation/Pocket Folder',
        image: 'document/marketing/presentation.svg',
        tips: 'Presentation and Pocket folder category.'
      },
      {
        id: 143,
        name: 'Signage/Poster',
        image: 'document/marketing/poster.svg',
        tips: 'Signage and Poster category.'
      }
    ]
  },
  /* POD Facility */
  {
    url: 'document/pid-109',
    title: 'POD Facility',
    subtitle: 'Small-run jobs utilizing large-format and/or high-volume laser or Inkjet printers.',
    category: '/document',
    prev: 'Custom Cut Sheet', prevStep: 'document/pid-101',
    products: [
      {
        id: 1440,
        name: 'POD Cut Sheet',
        image: 'document/pod-facility/scissors.svg',
        tips: 'POD Cut Sheet product.'
      },
      {
        id: 144,
        name: 'Flow Sheet/Oversized',
        image: 'document/pod-facility/page.svg',
        tips: 'Hospital Flow Sheets up to 14" X 26".'
      },
      {
        id: 145,
        name: 'Wide Format Poster',
        image: 'document/pod-facility/poster.svg',
        tips: 'Posters - up to 60" X 10\'. Max Qty 1000.'
      },
      {
        id: 146,
        name: 'Wide Format Rigid',
        image: 'document/pod-facility/blackboard.svg',
        tips: 'Foam Core, Sintra (PVC), Gator Board, Coroplast.'
      },
      {
        id: 147,
        name: 'Wide Format Vinyl',
        image: 'document/pod-facility/vinyl.svg',
        tips: 'Vinyl product up to 60" X 10\'.'
      },
      {
        id: 148,
        name: 'Wide Format/Yard Signs',
        image: 'document/pod-facility/open.svg',
        tips: 'Foam Core, Sintra (PVC), Gator Board, Coroplast.'
      },
      {
        id: 149,
        name: 'Wide Format Plastic',
        image: 'document/pod-facility/plastic-bag.svg',
        tips: 'Large up to 60" X 10\'.'
      },
      {
        id: 150,
        name: 'Black Toner Static',
        image: 'document/pod-facility/toner-single.svg',
        tips: 'Small Qty Printed Black Toner, less than 10,000.'
      },
      {
        id: 151,
        name: 'Black Toner Variable',
        image: 'document/pod-facility/toner.svg',
        tips: 'Small Qty Printed Black Toner, less than 10,000.'
      },
      {
        id: 152,
        name: 'Color Toner Static',
        image: 'document/pod-facility/toner-single-color.svg',
        tips: 'Small Qty Printed Color Toner, less than 10,000.'
      },
      {
        id: 153,
        name: 'Color Toner Variable',
        image: 'document/pod-facility/toner-color.svg',
        tips: 'Small Qty Printed Color Toner, less than 10,000.'
      },
      {
        id: 154,
        name: 'Color and Black Toner',
        image: 'document/pod-facility/ink.svg',
        tips: 'Oversize-Small Qty Printed Black Toner, less than 10,000.'
      },
      {
        id: 155,
        name: 'Laser Cut Sheet',
        image: 'document/pod-facility/laser-cutting-machine.svg',
        tips: 'Heat Resistant Ink, Max Quantity is 100,000.'
      },
      {
        id: 1550,
        name: 'Carbonless Sets',
        image: 'document/pod-facility/carbonless.svg',
        tips: 'Edge Glued Construction, Max Quantity is 100,000.'
      },
      {
        id: 156,
        name: 'Prescription Pads',
        image: 'document/pod-facility/prescription.svg',
        tips: 'Dr. Prescription Pads, Max Qty 10,000 sheets.'
      },
      {
        id: 157,
        name: 'Design on Demand',
        image: 'document/pod-facility/sketch.svg',
        tips: 'Product Ad Hock Forms, Max Qty 10,000.'
      },
      {
        id: 158,
        name: 'Design on Demand/Monthly',
        image: 'document/pod-facility/color-wheel.svg',
        tips: 'Contact Plant for More Information.'
      },
      {
        id: 159,
        name: 'Digital Color Books/Manuals',
        image: 'document/pod-facility/ebook.svg',
        tips: 'Books, Perfect Bound, Coil, Tape Binding, Saddle Stitch - Max Qty 2500.'
      },
      {
        id: 160,
        name: 'Digital Black Book/Manuals',
        image: 'document/pod-facility/ebook-black.svg',
        tips: 'Books, Perfect Bound, Coil, Tape Binding, Saddle Stitch - Max Qty 2500.'
      }
    ]
  },
  {
    url: 'document/pid-110',
    title: 'Non POD Facility',
    subtitle: 'Printed on a Press, High Volume Run.',
    category: '/document',
    prev: 'Custom Cut Sheet', prevStep: 'document/pid-101',
    products: [
      {
        id: 161,
        name: 'Prescription Form/Pad',
        image: 'document/non-pod-facility/medical-prescription.svg',
        tips: 'Forms used by Dr. to provide perscriptions to patients, packaged in a carton - individual sheets.'
      },
      {
        id: 162, name: 'Secure Document/Check',
        image: 'document/non-pod-facility/compliant.svg',
        tips: 'Document with security features (Checks) packaged in a carton - individual sheets.'
      },
      {
        id: 163,
        name: 'Form/Label Affixed/Liner',
        image: 'document/non-pod-facility/contact-form.svg',
        tips: 'Form with Label affixed - Piggy Back label with liner attached to cut sheet, packaged in a carton - individual sheets.'
      },
      {
        id: 164,
        name: 'Form/Label Integrated Liner',
        image: 'document/non-pod-facility/checklist.svg',
        tips: 'Form with die cut, adhesive, liner added to the product to create label, packaged in a carton - individual sheets.'
      },
      {
        id: 165,
        name: 'Pressure Seal',
        image: 'document/non-pod-facility/seal.svg',
        tips: 'Form with glue to create a mailer, packaged in a carton, individual sheets.'
      },
      {
        id: 166,
        name: 'High Color',
        image: 'document/non-pod-facility/color-wheel.svg',
        tips: 'Single Ply document with more than 6 ink colors, packaged in a carton - individual sheets.'
      },
      {
        id: 167,
        name: 'Standard Cut Sheet',
        image: 'document/non-pod-facility/cutting.svg',
        tips: 'Single ply document - no special features, packaged in a carton - individual sheets.'
      }
    ]
  },



  /* label Distribution */
  {
    url: 'label',
    title: 'Labels/Tape/Tags/Tickets',
    subtitle: 'Pressure Sensitive, Label/Form Combos, Affixed Labels, In-mold and tags',
    category: '/label',
    prev: 'Categories', prevStep: 'guide',
    products: [
      /*
      {
        id: 2001,
        name: 'Blank Custom Labels & Tape',
        image: 'label/custom-labels.png',
        tips: 'Blank Custom Labels & Tape product category.'
      },
      */
      {
        id: 2002,
        name: 'Blank and Press Printed Custom Labels & Tags',
        image: 'label/printed-press.png',
        tips: 'Press Printed Custom Labels & Tape product category.'
      },
      {
        id: 2003,
        name: 'Stock Labels - General Use',
        image: 'label/stock-labels.png',
        tips: 'Stock Labels - General Use product category.'
      },
      {
        id: 2004,
        name: 'Custom In-Mold Labels',
        image: 'label/in-mold.png',
        tips: 'Custom In-Mold Labels product category.'
      },
      {
        id: 2005,
        name: 'Tags & Tickets',
        image: 'label/tags-tickets.png',
        tips: 'Tags & Tickets product category.' },
      {
        id: 2006,
        name: 'Stock Labels & Tape - Healthcare',
        image: 'label/healthcare.png',
        tips: 'Stock Labels & Tape - Healthcare product category.'
      },
      {
        id: 2007,
        name: 'Other',
        image: 'label/others.svg',
        tips: 'Other product category.'
      }
    ]
  },
  {
    url: 'label/pid-2001',
    title: 'Blank Custom Labels & Tape',
    subtitle: 'Blank Custom Labels & Tape category.',
    category: '/label',
    prev: 'Labels/Tape/Tags/Tickets', prevStep: 'label',
    products: [
      {
        id: 2008,
        name: 'Roll',
        image: 'label/labels_tags/1_Roll/roll.svg',
        tips: 'Label Custom Roll - Blank.'
      },
      {
        id: 2009,
        name: 'Cutsheet',
        image: 'label/labels_tags/2_Cutsheet/cutsheet.svg',
        tips: 'Label Custom Cut Sheet - Blank.'
      },
      {
        id: 2010,
        name: 'Fanfold',
        image: 'label/labels_tags/3_Fanfold/fanfold.svg',
        tips: 'Label Custom Fanfold - Blank.'
      }
    ]
  },
  {
    url: 'label/pid-2002',
    title: 'Press Printed Custom Labels & Tape',
    subtitle: 'Press Printed Custom Labels & Tape category.',
    category: '/label',
    prev: 'Labels/Tape/Tags/Tickets', prevStep: 'label',
    products: [
      {
        id: 2011,
        name: 'Roll',
        image: 'label/printed_press/1_Roll/roll_printed.svg',
        tips: 'Label Custom Roll - Press Printed.'
      },
      {
        id: 2012,
        name: 'Cutsheet',
        image: 'label/printed_press/2_Cutsheet/cs_printed_cutsheet.svg',
        tips: 'Label Custom Cut Sheet - Press Printed'
      },
      {
        id: 2013,
        name: 'Fanfold',
        image: 'label/printed_press/3_Fanfold/fanfold_printed.svg',
        tips: 'Label Custom Fanfold - Press Printed.'
      }
    ]
  },
  {
    url: 'label/pid-2003',
    title: 'Stock Labels - General Use',
    subtitle: 'Stock Labels - General Use product category.',
    category: '/label',
    prev: 'Labels/Tape/Tags/Tickets', prevStep: 'label',
    products: [
      {
        id: 2014,
        name: 'Roll',
        image: 'label/stock_labels/1_Roll/roll_general_stock.svg',
        tips: 'Label Stock Roll.'
      },
      {
        id: 2015,
        name: 'Label',
        image: 'label/stock_labels/2_Cutsheet/cs_general_stock.svg',
        tips: 'Use this Product Code ONLY when the item does not match any of the other product codes. Be sure to check under "Specialty" before selecting this product code.'
      },
      {
        id: 2016,
        name: 'FanFold',
        image: 'label/stock_labels/3_Fanfold/fanfold_general_stock.svg',
        tips: 'Digitally produced labels that do not need to withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      }
    ]
  },
  {
    url: 'label/pid-2004',
    title: 'Custom In-Mold Labels',
    subtitle: 'Labels In Mold.',
    category: '/label',
    prev: 'Labels/Tape/Tags/Tickets', prevStep: 'label',
    products: [
      {
        id: 2017,
        name: 'Grafilm',
        image: 'label/in_mold/grafilm.svg',
        tips: 'Grafilm product category.'
      },
      {
        id: 2018,
        name: 'Thin Film',
        image: 'label/in_mold/thin-film.svg',
        tips: 'Thin Film product category.'
      },
      {
        id: 2019,
        name: 'Services & Tooling',
        image: 'label/in_mold/services.svg',
        tips: 'Services & Tooling product category.'
      }
    ]
  },
  {
    url: 'label/pid-2005',
    title: 'Tags & Tickets',
    subtitle: 'Tags & Tickets - Blank or Press Printed.',
    category: '/label',
    prev: 'Labels/Tape/Tags/Tickets', prevStep: 'label',
    products: [
      {
        id: 2020,
        name: 'Custom Tags',
        image: 'label/tags_tickets/custom-tags.svg',
        tips: 'Custom Tags product category.'
      },
      {
        id: 2021,
        name: 'Tags - Stock',
        image: 'label/labels_tags/new/75-604.png',
        tips: 'Tags.'
      },
      {
        id: 2022,
        name: 'Tickets',
        image: 'label/labels_tags/new/75-660.png',
        tips: 'Tickets.'
      },
      {
        id: 2023,
        name: 'Tags - Below Minimum',
        image: 'label/labels_tags/new/75-605.png',
        tips: 'Below Minimum tags.'
      },
      {
        id: 2024,
        name: 'Other (Dome, Cling, Clear Plate, Subsurface Print, Unsupported Film, Shrink Sleeve, Stretch Sleeve, Heat Transfer, other misc items)',
        image: 'label/labels_tags/new/75-500.png',
        tips: 'Any other specialty construction.'
      }
    ]
  },
  {
    url: 'label/pid-2006',
    title: 'Stock Labels & Tape - Healthcare',
    subtitle: 'Stock Labels & Tape - Healthcare product category.',
    category: '/label',
    prev: 'Labels/Tape/Tags/Tickets', prevStep: 'label',
    products: [
      {
        id: 2025,
        name: 'Roll',
        image: 'label/healthcare/1_Roll/roll_healthcare_stock.svg',
        tips: 'Roll product category.'
      },
      {
        id: 2026,
        name: 'Cutsheet',
        image: 'label/healthcare/2_Cutsheet/cs_healthcare_stock.svg',
        tips: 'Cutsheet product category.'
      },
      {
        id: 2027,
        name: 'FanFold',
        image: 'label/healthcare/3_Fanfold/fanfold_healthcare_stock.svg',
        tips: 'Fanfold product category.'
      }
    ]
  },
  {
    url: 'label/pid-2007',
    title: 'Other',
    subtitle: 'Labels Other.',
    category: '/label',
    prev: 'Labels/Tape/Tags/Tickets', prevStep: 'label',
    products: [
      {
        id: 2028,
        name: 'Rush Misc. Charges',
        image: 'label/labels_tags/new/70-990.png',
        tips: 'Rush charges for label orders.'
      },
      {
        id: 2029,
        name: 'Supply Management Approved',
        image: 'label/labels_tags/new/70-991.png',
        tips: 'For use on management supply approved sub contracted orders.'
      },
      {
        id: 2030,
        name: 'Tooling',
        image: 'label/labels_tags/new/70-992.png',
        tips: 'Tooling charges for label orders.'
      },
      {
        id: 2031,
        name: 'Label Licensed Product',
        image: 'label/labels_tags/new/70-995.png',
        tips: 'For use on licensed label products where we pay license fees.'
      },
      {
        id: 2032,
        name: 'Label Kit',
        image: 'label/labels_tags/new/70-998.png',
        tips: 'Label orders that includes labels and thermal transfer ribbons in the same carton.'
      },
      {
        id: 2033,
        name: 'Misc. Label Other',
        image: 'label/labels_tags/new/70-999.png',
        tips: 'For use when no other product code fits the label order.'
      }
    ]
  },
  {
    url: 'label/pid-2008',
    title: 'Roll',
    subtitle: 'Label Custom Roll - Blank.',
    category: '/label',
    prev: 'Blank Custom Labels & Tape', prevStep: 'label/pid-2001',
    products: [
      {
        id: 2034,
        name: 'Label',
        image: 'label/labels_tags/1_Roll/roll_label.svg',
        tips: 'Label product category.'
      },
      {
        id: 2035,
        name: 'Durable',
        image: 'label/labels_tags/1_Roll/roll_durable.svg',
        tips: 'Durable product category.'
      },
      {
        id: 2036,
        name: 'Label - Subcon Below Minimum',
        image: 'label/labels_tags/new/54-550.png',
        tips: 'Orders that fall below the minimum threashold for internal production that require oursourcing.'
      },
      {
        id: 2037,
        name: 'Specialty',
        image: 'label/labels_tags/1_Roll/roll_specialty.svg',
        tips: 'Label Custom Roll - Specialty (Blank or Press Printed).'
      }
    ]
  },
  {
    url: 'label/pid-2009',
    title: 'Cutsheet',
    subtitle: 'Label Custom Cut Sheet - Blank',
    category: '/label',
    prev: 'Blank Custom Labels & Tape', prevStep: 'label/pid-2001',
    products: [
      {
        id: 2038,
        name: 'Label',
        image: 'label/labels_tags/2_Cutsheet/label.svg',
        tips: 'Label product category.'
      },
      {
        id: 2039,
        name: 'Durable',
        image: 'label/labels_tags/2_Cutsheet/durable.svg',
        tips: 'Durable product category.'
      },
      {
        id: 2040,
        name: 'Label - Subcon Below Minimum',
        image: 'label/labels_tags/new/51-550.png',
        tips: 'Orders that fall below the minimum threashold for internal production that require oursourcing.'
      },
      {
        id: 2041,
        name: 'Specialty',
        image: 'label/labels_tags/2_Cutsheet/specialty.svg',
        tips: 'Label Custom Cut Sheet - Specialty (Blank or Press Printed).'
      }
    ]
  },
  {
    url: 'label/pid-2010',
    title: 'Fanfold',
    subtitle: 'Label Custom Fanfold - Blank.',
    category: '/label',
    prev: 'Blank Custom Labels & Tape', prevStep: 'label/pid-2001',
    products: [
      {
        id: 2042,
        name: 'Label',
        image: 'label/labels_tags/3_Fanfold/fanfold_label.svg',
        tips: 'Label product category.'
      },
      {
        id: 2043,
        name: 'Durable',
        image: 'label/labels_tags/3_Fanfold/fanfold_durable.svg',
        tips: 'Durable product category.'
      },
      {
        id: 2044,
        name: 'Label - Subcon Below Minimum',
        image: 'label/labels_tags/new/57-550.png',
        tips: 'Orders that fall below the minimum threashold for internal production that require oursourcing.'
      },
      {
        id: 2045,
        name: 'Specialty',
        image: 'label/labels_tags/3_Fanfold/fanfold_specialty.svg',
        tips: 'Label Custom Fanfold - Specialty (Blank or Press Printed).'
      }
    ]
  },
  {
    url: 'label/pid-2011',
    title: 'Roll',
    subtitle: 'Label Custom Roll - Press Printed.',
    category: '/label',
    prev: 'Press Printed Custom Labels & Tape', prevStep: 'label/pid-2002',
    products: [
      {
        id: 2046,
        name: 'Label',
        image: 'label/printed_press/1_Roll/roll_printed_label.svg',
        tips: 'Label product category.'
      },
      {
        id: 2047,
        name: 'Durable',
        image: 'label/printed_press/1_Roll/roll_printed_durable.svg',
        tips: 'Durable product category.'
      },
      {
        id: 2048,
        name: 'Label - Subcon Below Minimum',
        image: 'label/labels_tags/new/55-550.png',
        tips: 'Orders that fall below the minimum threashold for internal production that require oursourcing.'
      },
      {
        id: 2049,
        name: 'Specialty',
        image: 'label/printed_press/1_Roll/roll_printed_other.svg',
        tips: 'Label Custom Roll - Specialty (Blank or Press Printed).'
      }
    ]
  },
  {
    url: 'label/pid-2012',
    title: 'Cutsheet',
    subtitle: 'Label Custom Cut Sheet - Press Printed',
    category: '/label',
    prev: 'Press Printed Custom Labels & Tape', prevStep: 'label/pid-2002',
    products: [
      {
        id: 2050,
        name: 'Label',
        image: 'label/printed_press/2_Cutsheet/cs_printed_label.svg',
        tips: 'Label product category.'
      },
      {
        id: 2051,
        name: 'Durable',
        image: 'label/printed_press/2_Cutsheet/cs_printed_durable.svg',
        tips: 'Durable product category.'
      },
      {
        id: 2052,
        name: 'Label - Subcon Below Minimum',
        image: 'label/labels_tags/new/52-550.png',
        tips: 'Orders that fall below the minimum threashold for internal production that require oursourcing.'
      },
      {
        id: 2053,
        name: 'Specialty',
        image: 'label/printed_press/2_Cutsheet/cs_printed_specialty.svg',
        tips: 'Label Custom Cut Sheet - Specialty (Blank or Press Printed).'
      }
    ]
  },
  {
    url: 'label/pid-2013',
    title: 'Fanfold',
    subtitle: 'Label Custom Fanfold - Press Printed.',
    category: '/label',
    prev: 'Press Printed Custom Labels & Tape', prevStep: 'label/pid-2002',
    products: [
      {
        id: 2054,
        name: 'Label',
        image: 'label/printed_press/3_Fanfold/fanfold_printed_label.svg',
        tips: 'Label product category.'
      },
      {
        id: 2055,
        name: 'Durable',
        image: 'label/printed_press/3_Fanfold/fanfold_printed_durable.svg',
        tips: 'Durable product category.'
      },
      {
        id: 2056,
        name: 'Label - Subcon Below Minimum',
        image: 'label/labels_tags/new/59-550.png',
        tips: 'Orders that fall below the minimum threashold for internal production that require oursourcing.'
      },
      {
        id: 2057,
        name: 'Specialty',
        image: 'label/printed_press/3_Fanfold/fanfold_printed_specialty.svg',
        tips: 'Label Custom Fanfold - Specialty (Blank or Press Printed).'
      }
    ]
  },
  {
    url: 'label/pid-2014',
    title: 'Roll',
    subtitle: 'Label Stock Roll - General Use.',
    category: '/label',
    prev: 'Stock Labels - General Use', prevStep: 'label/pid-2003',
    products: [
      {
        id: 2058,
        name: 'Blank Label',
        image: 'label/labels_tags/new/62-110.png',
        tips: 'Blank General Use Stock Roll Labels.'
      },
      {
        id: 2059,
        name: 'Printed Label',
        image: 'label/labels_tags/new/63-110.png',
        tips: 'Pre-Printed General Use Stock Roll Labels.'
      },
      {
        id: 2060,
        name: 'Specialty',
        image: 'label/stock_labels/1_Roll/roll_general_stock_specialty.svg',
        tips: 'Label Stock Cut Sheet - General Use - Specialty (Blank or Press Printed).'
      },
    ]
  },
  {
    url: 'label/pid-2015',
    title: 'Cutsheet',
    subtitle: 'Label Stock Cut Sheet.',
    category: '/label',
    prev: 'Stock Labels - General Use', prevStep: 'label/pid-2003',
    products: [
      {
        id: 2061,
        name: 'Blank Label',
        image: 'label/labels_tags/new/60-110.png',
        tips: 'Blank General Use Stock Cut Sheet Labels.'
      },
      {
        id: 2062,
        name: 'Printed Label',
        image: 'label/labels_tags/new/61-110.png',
        tips: 'Pre-Printed General Use Stock Cut Sheet Labels.'
      },
      {
        id: 2063,
        name: 'Specialty',
        image: 'label/stock_labels/2_Cutsheet/cs_general_stock_specialty.svg',
        tips: 'Label Stock Cut Sheet - General Use - Specialty (Blank or Press Printed).'
      }
    ]
  },
  {
    url: 'label/pid-2016',
    title: 'FanFold',
    subtitle: 'Label Stock Fanfold - General Use - Blank.',
    category: '/label',
    prev: 'Stock Labels - General Use', prevStep: 'label/pid-2003',
    products: [
      {
        id: 2064,
        name: 'Blank Label',
        image: 'label/labels_tags/new/64-110.png',
        tips: 'Blank General Use Stock Fanfold Labels.'
      },
      {
        id: 2065,
        name: 'Printed Label',
        image: 'label/labels_tags/new/65-110.png',
        tips: 'Pre-Printed General Use Stock Fanfold Labels.'
      },
      {
        id: 2066,
        name: 'Specialty',
        image: 'label/stock_labels/3_Fanfold/fanfold_general_stock_specialty.svg',
        tips: 'Label Stock Cut Sheet - General Use - Specialty (Blank or Press Printed).'
      }
    ]
  },
  {
    url: 'label/pid-2017',
    title: 'Grafilm',
    subtitle: 'Grafilm product category.',
    category: '/label',
    prev: 'Custom In-Mold Labels', prevStep: 'label/pid-2004',
    products: [
      {
        id: 2070,
        name: '3D GRAFILM - PMS SPOT COLOR',
        image: 'label/labels_tags/new/71-580.png',
        tips: 'GRAFILM PMS SPOT COLOR for In-mold labels.'
      },
      {
        id: 2071,
        name: '3D GRAFILM PROCESS PRINT - 4+ COLOR',
        image: 'label/labels_tags/new/71-581.png',
        tips: 'GRAFILM PROCESS PRINT COLOR for In-mold labels.'
      },
      {
        id: 2072,
        name: 'DIGITAL GRAFFILM',
        image: 'label/labels_tags/new/71-583.png',
        tips: 'GRAFFILM for In-mold labels.'
      }
    ]
  },
  {
    url: 'label/pid-2018',
    title: 'Thin Film',
    subtitle: 'Thin Film category.',
    category: '/label',
    prev: 'Custom In-Mold Labels', prevStep: 'label/pid-2004',
    products: [
      {
        id: 2073,
        name: 'THIN FILM-PMS SPOT COLOR',
        image: 'label/labels_tags/new/71-592.png',
        tips: 'FILM PMS SPOT COLOR for In-mold labels.'
      },
      {
        id: 2074,
        name: 'THIN FILM-PROCESS PRINT - 4+ COLOR',
        image: 'label/labels_tags/new/71-593.png',
        tips: 'FILM PROCESS PRINT COLOR for In-mold labels.'
      },
      {
        id: 2075,
        name: 'DIGITAL THIN FILM',
        image: 'label/labels_tags/new/71-591.png',
        tips: 'Digitally printed THIN FILM for In-mold labels.'
      }
    ]
  },
  {
    url: 'label/pid-2019',
    title: 'Services & Tooling',
    subtitle: 'Services & Tooling category.',
    category: '/label',
    prev: 'Custom In-Mold Labels', prevStep: 'label/pid-2004',
    products: [
      {
        id: 2076,
        name: 'IML Design Services',
        image: 'label/labels_tags/new/71-570.png',
        tips: 'Design Services for In-mold labels.'
      },
      {
        id: 2077,
        name: 'IML Consulting Services',
        image: 'label/labels_tags/new/71-571.png',
        tips: 'Consulting Services for In-mold labels.'
      },
      {
        id: 2078,
        name: 'IML Customer Product Development',
        image: 'label/labels_tags/new/71-572.png',
        tips: 'Customer Product Development for In-mold labels.'
      },
      {
        id: 2079,
        name: 'IML Tooling',
        image: 'label/labels_tags/new/71-573.png',
        tips: 'Tooling for In-mold labels.'
      }
    ]
  },
  {
    url: 'label/pid-2020',
    title: 'Custom Tags',
    subtitle: 'Custom Tags category.',
    category: '/label',
    prev: 'Custom In-Mold Labels', prevStep: 'label/pid-2005',
    products: [
      {
        id: 2080,
        name: 'Tags - Custom PS',
        image: 'label/labels_tags/new/75-601.png',
        tips: 'Pressure Sensitive tags.'
      },
      {
        id: 2081,
        name: 'Tags - Custom Non-PS',
        image: 'label/labels_tags/new/75-602.png',
        tips: 'Non Pressure Sensitive tags.'
      },
      {
        id: 2082,
        name: 'Tags - Custom w/Reinforcement and / or Attachment',
        image: 'label/labels_tags/new/75-603.png',
        tips: 'Custom w Reinforcement and or Attachment tags.'
      },
      {
        id: 2083,
        name: 'Tags - RFID',
        image: 'label/labels_tags/new/75-670.png',
        tips: 'Any tag or ticket construction that includes a RFID inlay as part of the specifications.'
      }
    ]
  },
  {
    url: 'label/pid-2025',
    title: 'Roll',
    subtitle: 'Roll category.',
    category: '/label',
    prev: 'Stock Labels - General Use', prevStep: 'label/pid-2006',
    products: [
      {
        id: 2084,
        name: 'Blank Label',
        image: 'label/labels_tags/new/93-110.png',
        tips: 'Blank Stock Healthcare Roll Labels.'
      },
      {
        id: 2085,
        name: 'Printed Label',
        image: 'label/labels_tags/new/94-110.png',
        tips: 'Pre-Printed Stock Healthcare Roll Labels.'
      },
      {
        id: 2086,
        name: 'Specialty Below Min',
        image: 'label/healthcare/1_Roll/roll_healthcare_stock_specialty.svg',
        tips: 'Label Stock Roll - Healthcare - Specialty (Blank or Press Printed).'
      }
    ]
  },
  {
    url: 'label/pid-2026',
    title: 'Cutsheet',
    subtitle: 'Label Stock Cut Sheet - Healthcare',
    category: '/label',
    prev: 'Stock Labels - General Use', prevStep: 'label/pid-2006',
    products: [
      {
        id: 2087,
        name: 'Blank Label',
        image: 'label/labels_tags/new/91-110.png',
        tips: 'Blank Stock Healthcare Cut Sheet Labels.'
      },
      {
        id: 2088,
        name: 'Printed Label',
        image: 'label/labels_tags/new/92-110.png',
        tips: 'Pre-Printed Stock Healthcare Cut Sheet Labels.'
      },
      {
        id: 2089,
        name: 'Specialty Below Min',
        image: 'label/healthcare/2_Cutsheet/cs_healthcare_stock_specialty.svg',
        tips: 'Label Stock Cut Sheet - Healthcare - Specialty (Blank or Press Printed).'
      }
    ]
  },
  {
    url: 'label/pid-2027',
    title: 'FanFold',
    subtitle: 'Fanfold category.',
    category: '/label',
    prev: 'Stock Labels - General Use', prevStep: 'label/pid-2006',
    products: [
      {
        id: 2090,
        name: 'Blank Label',
        image: 'label/labels_tags/new/95-110.png',
        tips: 'Blank Stock Healthcare Fanfold Labels.'
      },
      {
        id: 2091,
        name: 'Printed Label',
        image: 'label/labels_tags/new/96-110.png',
        tips: 'Pre-Printed Stock Healthcare Fanfold Labels.'
      },
      {
        id: 2092,
        name: 'Specialty Below Min',
        image: 'label/healthcare/3_Fanfold/fanfold_healthcare_stock_specialty.svg',
        tips: 'Label Stock Fanfold - Healthcare - Specialty (Blank or Press Printed).'
      }
    ]
  },
  {
    url: 'label/pid-2034',
    title: 'Label',
    subtitle: 'Label category.',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2008',
    products: [
      {
        id: 2093,
        name: 'Label',
        image: 'label/labels_tags/new/54-110.png',
        tips: 'Use this Product Code ONLY when the item does not match any of the other product codes. Be sure to check under "Specialty" before selecting this product code.'
      },
      {
        id: 2094,
        name: 'Digital Non-Durable',
        image: 'label/labels_tags/new/54-111.png',
        tips: 'Digitally produced labels that do not need to withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      }
    ]
  },
  {
    url: 'label/pid-2035',
    title: 'Durable',
    subtitle: 'Durable category.',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2008',
    products: [
      {
        id: 2095,
        name: 'Durable-Flexo',
        image: 'label/labels_tags/new/54-210.png',
        tips: 'Labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      },
      {
        id: 2096,
        name: 'Digital Durable',
        image: 'label/labels_tags/new/54-211.png',
        tips: 'Digitally produced labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity. '
      }
    ]
  },
  {
    url: 'label/pid-2037',
    title: 'Specialty',
    subtitle: 'Label Custom Roll - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2008',
    products: [
      {
        id: 2097,
        name: 'Affixed (Smooth Seal or Nested)',
        image: 'label/labels_tags/new/54-310.png',
        tips: 'Documents with a label affixed to a substrate such as a form or another label. This includes silicone spot, linered labels, and nested label constructions.'
      },
      {
        id: 2098,
        name: 'Pattern Press',
        image: 'label/labels_tags/new/56-360.png',
        tips: 'Any adhesive pattern other than full adhesive coating.'
      },
      {
        id: 2099,
        name: 'Wrist Band',
        image: 'label/labels_tags/new/56-400.png',
        tips: 'Any label construction that results in a wristband die design.'
      },
      {
        id: 2100,
        name: 'Linerless',
        image: 'label/labels_tags/new/56-350.png',
        tips: 'Linerless labels are pressure sensitive labels that do not have a release liner and are used to provide information. They are similar to tape but are not used to seal packages.'
      },
      {
        id: 2101,
        name: 'Bag Tags - Airlines',
        image: 'label/labels_tags/new/54-320.png',
        tips: 'Labels constructions for use as airline bag tags.'
      },
      {
        id: 2102,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/56-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2103,
        name: 'RFID',
        image: 'label/labels_tags/new/53-370.png',
        tips: 'Any label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2104,
        name: 'DMV Decal or Form w/Silicone Patch',
        image: 'label/labels_tags/new/54-330.png',
        tips: 'Form label combinations with silicone patch for use as DMV registration forms.'
      },
      {
        id: 2105,
        name: 'Tapes (Non Packaging)',
        image: 'label/labels_tags/new/56-351.png',
        tips: 'Tapes are similar to linerless label but are defined by their end use as a package sealing solution.'
      },
      {
        id: 2106,
        name: 'Other (Dome, Cling, Clear Plate, Subsurface Print, Unsupported Film, Shrink Sleeve, Stretch Sleeve, Heat Transfer, other misc items)',
        image: 'label/labels_tags/new/56-500.png',
        tips: 'Any other specialty construction.'
      }
    ]
  },
  {
    url: 'label/pid-2038',
    title: 'Label',
    subtitle: 'Label category.',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2009',
    products: [
      {
        id: 2107,
        name: 'Label',
        image: 'label/labels_tags/new/51-110.png',
        tips: 'Use this Product Code ONLY when the item does not match any of the other product codes. Be sure to check under "Specialty" before selecting this product code.'
      },
      {
        id: 2108,
        name: 'Digital Non-Durable',
        image: 'label/labels_tags/new/51-111.png',
        tips: 'Digitally produced labels that do not need to withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      }
    ]
  },
  {
    url: 'label/pid-2039',
    title: 'Durable',
    subtitle: 'Durable category.',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2009',
    products: [
      {
        id: 2109,
        name: 'Durable',
        image: 'label/labels_tags/new/51-210.png',
        tips: 'Labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      },
      {
        id: 2110,
        name: 'Digital Durable',
        image: 'label/labels_tags/new/51-211.png',
        tips: 'Digitally produced labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      }
    ]
  },
  {
    url: 'label/pid-2041',
    title: 'Specialty',
    subtitle: 'Label Custom Cut Sheet - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2009',
    products: [
      {
        id: 2111,
        name: 'Affixed (Smooth Seal or Nested)',
        image: 'label/labels_tags/new/51-310.png',
        tips: 'Documents with a label affixed to a substrate such as a form or another label. This includes silicone spot, linered labels, and nested label constructions.'
      },
      {
        id: 2112,
        name: 'Pattern Press',
        image: 'label/labels_tags/new/53-360.png',
        tips: 'Any adhesive pattern other than full adhesive coating.'
      },
      {
        id: 2113,
        name: 'Wrist Band',
        image: 'label/labels_tags/new/53-400.png',
        tips: 'Any label construction that results in a wristband die design. '
      },
      {
        id: 2114,
        name: 'Bag Tags - Airlines',
        image: 'label/labels_tags/new/51-320.png',
        tips: 'Labels constructions for use as airline bag tags.'
      },
      {
        id: 2115,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/53-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2116,
        name: 'RFID',
        image: 'label/labels_tags/new/53-370.png',
        tips: 'Any label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2117,
        name: 'DMV Decal or Form w/Silicone Patch',
        image: 'label/labels_tags/new/51-330.png',
        tips: 'Form label combinations with silicone patch for use as DMV registration forms.'
      },
      {
        id: 2118,
        name: 'Other (Dome, Cling, Clear Plate, Subsurface Print, Unsupported Film, Shrink Sleeve, Stretch Sleeve, Heat Transfer, other misc items)',
        image: 'label/labels_tags/new/53-500.png',
        tips: 'Any other specialty construction.'
      }
    ]
  },
  {
    url: 'label/pid-2042',
    title: 'Label',
    subtitle: 'Label category.',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2010',
    products: [
      {
        id: 2119,
        name: 'Label',
        image: 'label/labels_tags/new/57-110.png',
        tips: 'Use this Product Code ONLY when the item does not match any of the other product codes. Be sure to check under "Specialty" before selecting this product code.'
      },
      {
        id: 2120,
        name: 'Digital Non-Durable',
        image: 'label/labels_tags/new/57-111.png',
        tips: 'Digitally produced labels that do not need to withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      }
    ]
  },
  {
    url: 'label/pid-2043',
    title: 'Durable',
    subtitle: 'Durable category.',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2010',
    products: [
      {
        id: 2121,
        name: 'Durable-Flexo',
        image: 'label/labels_tags/new/57-210.png',
        tips: 'Labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      },
      {
        id: 2122,
        name: 'Digital Durable',
        image: 'label/labels_tags/new/57-211.png',
        tips: 'Digitally produced labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity. '
      }
    ]
  },
  {
    url: 'label/pid-2045',
    title: 'Specialty',
    subtitle: 'Label Custom Fanfold - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2010',
    products: [
      {
        id: 2123,
        name: 'Affixed (Smooth Seal or Nested)',
        image: 'label/labels_tags/new/57-310.png',
        tips: 'Documents with a label affixed to a substrate such as a form or another label. This includes silicone spot, linered labels, and nested label constructions.'
      },
      {
        id: 2124,
        name: 'Pattern Press',
        image: 'label/labels_tags/new/72-360.png',
        tips: 'Any adhesive pattern other than full adhesive coating.'
      },
      {
        id: 2125,
        name: 'Wrist Band',
        image: 'label/labels_tags/new/72-400.png',
        tips: 'Any label construction that results in a wristband die design.'
      },
      {
        id: 2126,
        name: 'Bag Tags - Airlines',
        image: 'label/labels_tags/new/57-320.png',
        tips: 'Labels constructions for use as airline bag tags.'
      },
      {
        id: 2127,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/72-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2128,
        name: 'RFID',
        image: 'label/labels_tags/new/72-370.png',
        tips: 'Any label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2129,
        name: 'DMV Decal or Form w/Silicone Patch',
        image: 'label/labels_tags/new/57-330.png',
        tips: 'Form label combinations with silicone patch for use as DMV registration forms.'
      },
      {
        id: 2130,
        name: 'Other (Dome, Cling, Clear Plate, Subsurface Print, Unsupported Film, Shrink Sleeve, Stretch Sleeve, Heat Transfer, other misc items)',
        image: 'label/labels_tags/new/72-500.png',
        tips: 'Any other specialty construction.'
      }
    ]
  },
  {
    url: 'label/pid-2046',
    title: 'Roll Label',
    subtitle: 'Roll Label category.',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2011',
    products: [
      {
        id: 2131,
        name: 'Roll Label',
        image: 'label/labels_tags/new/55-110.png',
        tips: 'Use this Product Code ONLY when the item does not match any of the other product codes. Be sure to check under "Specialty" before selecting this product code.'
      },
      {
        id: 2132,
        name: 'Digital Non-Durable',
        image: 'label/labels_tags/new/55-111.png',
        tips: 'Digitally produced labels that do not need to withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      }
    ]
  },
  {
    url: 'label/pid-2047',
    title: 'Durable',
    subtitle: 'Durable category.',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2011',
    products: [
      {
        id: 2133,
        name: 'Durable-Flexo',
        image: 'label/labels_tags/new/55-210.png',
        tips: 'Labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      },
      {
        id: 2134,
        name: 'Digital Durable',
        image: 'label/labels_tags/new/55-211.png',
        tips: 'Digitally produced labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity. '
      }
    ]
  },
  {
    url: 'label/pid-2049',
    title: 'Specialty',
    subtitle: 'Label Custom Roll - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2011',
    products: [
      {
        id: 2135,
        name: 'Affixed (Smooth Seal or Nested)',
        image: 'label/labels_tags/new/55-310.png',
        tips: 'Documents with a label affixed to a substrate such as a form or another label. This includes silicone spot, linered labels, and nested label constructions.'
      },
      {
        id: 2136,
        name: 'Pattern Press',
        image: 'label/labels_tags/new/56-360.png',
        tips: 'Any adhesive pattern other than full adhesive coating.'
      },
      {
        id: 2137,
        name: 'Wrist Band',
        image: 'label/labels_tags/new/56-400.png',
        tips: 'Any label construction that results in a wristband die design.'
      },
      {
        id: 2138,
        name: 'Linerless',
        image: 'label/labels_tags/new/56-350.png',
        tips: 'Linerless labels are pressure sensitive labels that do not have a release liner and are used to provide information. They are similar to tape but are not used to seal packages.'
      },
      {
        id: 2139,
        name: 'Screen Print',
        image: 'label/labels_tags/new/55-212.png',
        tips: 'Label orders that require screen press production. Be sure to investigate digital durable production as an alternative production method.'
      },
      {
        id: 2140,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/56-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2141,
        name: 'RFID',
        image: 'label/labels_tags/new/53-370.png',
        tips: 'Any label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2142,
        name: 'DMV Decal or Form w/Silicone Patch',
        image: 'label/labels_tags/new/55-330.png',
        tips: 'Form label combinations with silicone patch for use as DMV registration forms.'
      },
      {
        id: 2143,
        name: 'Tapes (Non Packaging)',
        image: 'label/labels_tags/new/56-351.png',
        tips: 'Tapes are similar to linerless label but are defined by their end use as a package sealing solution.'
      },
      {
        id: 2144,
        name: 'Bag Tags - Airlines',
        image: 'label/labels_tags/new/55-320.png',
        tips: 'Labels constructions for use as airline bag tags.'
      },
      {
        id: 2145,
        name: 'Other (Dome, Cling, Clear Plate, Subsurface Print, Unsupported Film, Shrink Sleeve, Stretch Sleeve, Heat Transfer, other misc items)',
        image: 'label/labels_tags/new/56-500.png',
        tips: 'Any other specialty construction.'
      }
    ]
  },
  {
    url: 'label/pid-2050',
    title: 'Cutsheet Label',
    subtitle: 'Cutsheet Label category.',
    category: '/label',
    prev: 'Cutsheet', prevStep: 'label/pid-2012',
    products: [
      {
        id: 2146,
        name: 'Cutsheet Label',
        image: 'label/labels_tags/new/52-110.png',
        tips: 'Use this Product Code ONLY when the item does not match any of the other product codes. Be sure to check under "Specialty" before selecting this product code.'
      },
      {
        id: 2147,
        name: 'Digital Non-Durable',
        image: 'label/labels_tags/new/52-111.png',
        tips: 'Digitally produced labels that do not need to withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      }
    ]
  },
  {
    url: 'label/pid-2051',
    title: 'Durable',
    subtitle: 'Durable category.',
    category: '/label',
    prev: 'Cutsheet', prevStep: 'label/pid-2012',
    products: [
      {
        id: 2148,
        name: 'Durable-Flexo',
        image: 'label/labels_tags/new/52-210.png',
        tips: 'Labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      },
      {
        id: 2149,
        name: 'Digital Durable',
        image: 'label/labels_tags/new/52-211.png',
        tips: 'Digitally produced labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      }
    ]
  },
  {
    url: 'label/pid-2053',
    title: 'Specialty',
    subtitle: 'Label Custom Cut Sheet - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Cutsheet', prevStep: 'label/pid-2012',
    products: [
      {
        id: 2150,
        name: 'Affixed (Smooth Seal or Nested)',
        image: 'label/labels_tags/new/52-310.png',
        tips: 'Documents with a label affixed to a substrate such as a form or another label. This includes silicone spot, linered labels, and nested label constructions.'
      },
      {
        id: 2151,
        name: 'Pattern Press',
        image: 'label/labels_tags/new/53-360.png',
        tips: 'Any adhesive pattern other than full adhesive coating.'
      },
      {
        id: 2152,
        name: 'Cutsheet Wristband',
        image: 'label/labels_tags/new/53-400.png',
        tips: 'Any label construction that results in a wristband die design.'
      },
      {
        id: 2153,
        name: 'Screen Print',
        image: 'label/labels_tags/new/52-212.png',
        tips: 'Label orders that require screen press production. Be sure to investigate digital durable production as an alternative production method.'
      },
      {
        id: 2154,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/53-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2155,
        name: 'RFID',
        image: 'label/labels_tags/new/53-370.png',
        tips: 'Any label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2156,
        name: 'DMV Decal or Form w/Silicone Patch',
        image: 'label/labels_tags/new/52-330.png',
        tips: 'Form label combinations with silicone patch for use as DMV registration forms.'
      },
      {
        id: 2157,
        name: 'Bag Tags - Airlines',
        image: 'label/labels_tags/new/52-320.png',
        tips: 'Labels constructions for use as airline bag tags.'
      },
      {
        id: 2158,
        name: 'Other (Dome, Cling, Clear Plate, Subsurface Print, Unsupported Film, Shrink Sleeve, Stretch Sleeve, Heat Transfer, other misc items)',
        image: 'label/labels_tags/new/53-500.png',
        tips: 'Any other specialty construction.'
      }
    ]
  },
  {
    url: 'label/pid-2054',
    title: 'Fanfold Label',
    subtitle: 'Fanfold Label category.',
    category: '/label',
    prev: 'Fanfold', prevStep: 'label/pid-2013',
    products: [
      {
        id: 2159,
        name: 'Fanfold Label',
        image: 'label/labels_tags/new/59-110.png',
        tips: 'Use this Product Code ONLY when the item does not match any of the other product codes. Be sure to check under "Specialty" before selecting this product code.'
      },
      {
        id: 2160,
        name: 'Digital Non-Durable',
        image: 'label/labels_tags/new/59-111.png',
        tips: 'Digitally produced labels that do not need to withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      }
    ]
  },
  {
    url: 'label/pid-2055',
    title: 'Durable',
    subtitle: 'Durable category.',
    category: '/label',
    prev: 'Fanfold', prevStep: 'label/pid-2013',
    products: [
      {
        id: 2161,
        name: 'Durable-Flexo',
        image: 'label/labels_tags/new/59-210.png',
        tips: 'Labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity.'
      },
      {
        id: 2162,
        name: 'Digital Durable',
        image: 'label/labels_tags/new/59-211.png',
        tips: 'Digitally produced labels that must withstand harsh end use environments such as outdoor, abrasion, chemicals, heat and other factors that could cause the label to fail its intended use and longevity. '
      }
    ]
  },
  {
    url: 'label/pid-2057',
    title: 'Specialty',
    subtitle: 'Label Custom Fanfold - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Fanfold', prevStep: 'label/pid-2013',
    products: [
      {
        id: 2163,
        name: 'Affixed (Smooth Seal or Nested)',
        image: 'label/labels_tags/new/59-310.png',
        tips: 'Documents with a label affixed to a substrate such as a form or another label. This includes silicone spot, linered labels, and nested label constructions.'
      },
      {
        id: 2164,
        name: 'Pattern Press',
        image: 'label/labels_tags/new/72-360.png',
        tips: 'Any adhesive pattern other than full adhesive coating.'
      },
      {
        id: 2165,
        name: 'Wrist Band',
        image: 'label/labels_tags/new/72-400.png',
        tips: 'Any label construction that results in a wristband die design.'
      },
      {
        id: 2166,
        name: 'Bag Tags - Airlines',
        image: 'label/labels_tags/new/59-320.png',
        tips: 'Labels constructions for use as airline bag tags.'
      },
      {
        id: 2167,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/56-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2168,
        name: 'RFID',
        image: 'label/labels_tags/new/72-370.png',
        tips: 'Any label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2169,
        name: 'DMV Decal or Form w/Silicone Patch',
        image: 'label/labels_tags/new/59-330.png',
        tips: 'Form label combinations with silicone patch for use as DMV registration forms.'
      },
      {
        id: 2170,
        name: 'Other (Dome, Cling, Clear Plate, Subsurface Print, Unsupported Film, Shrink Sleeve, Stretch Sleeve, Heat Transfer, other misc items)',
        image: 'label/labels_tags/new/72-500.png',
        tips: 'Any other specialty construction.'
      }
    ]
  },
  {
    url: 'label/pid-2060',
    title: 'Specialty',
    subtitle: 'Label Stock Cut Sheet - General Use - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2014',
    products: [
      {
        id: 2171,
        name: 'Wrist Band',
        image: 'label/labels_tags/new/67-400.png',
        tips: 'Any label construction that results in a wristband die design.'
      },
      {
        id: 2172,
        name: 'Tapes (Non Packaging)',
        image: 'label/labels_tags/new/67-351.png',
        tips: 'Tapes are similar to linerless label but are defined by their end use as a package sealing solution.'
      },
      {
        id: 2173,
        name: 'Linerless',
        image: 'label/labels_tags/new/67-350.png',
        tips: 'Linerless labels are pressure sensitive labels that do not have a release liner and are used to provide information. They are similar to tape but are not used to seal packages.'
      },
      {
        id: 2174,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/67-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2175,
        name: 'RFID',
        image: 'label/labels_tags/new/67-370.png',
        tips: 'Any stock label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2176,
        name: 'Misc. Label Other',
        image: 'label/labels_tags/new/70-999.png',
        tips: 'For use when no other product code fits the label order.'
      }
    ]
  },
  {
    url: 'label/pid-2063',
    title: 'Specialty',
    subtitle: 'Label Stock Cut Sheet - General Use - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Cutsheet', prevStep: 'label/pid-2015',
    products: [
      {
        id: 2177,
        name: 'Wrist Band',
        image: 'label/labels_tags/new/66-400.png',
        tips: 'Any label construction that results in a wristband die design.'
      },
      {
        id: 2178,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/66-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2179,
        name: 'RFID',
        image: 'label/labels_tags/new/66-370.png',
        tips: 'Any label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2180,
        name: 'Misc. Label Other',
        image: 'label/labels_tags/new/70-999.png',
        tips: 'For use when no other product code fits the label order.'
      }
    ]
  },
  {
    url: 'label/pid-2066',
    title: 'Specialty',
    subtitle: 'Label Stock Cut Sheet - General Use - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Fanfold', prevStep: 'label/pid-2016',
    products: [
      {
        id: 2181,
        name: 'Wrist Band',
        image: 'label/labels_tags/new/69-400.png',
        tips: 'Any label construction that results in a wristband die design.'
      },
      {
        id: 2182,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/69-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2183,
        name: 'RFID',
        image: 'label/labels_tags/new/69-370.png',
        tips: 'Any stock label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2184,
        name: 'Misc. Label Other',
        image: 'label/labels_tags/new/70-999.png',
        tips: 'For use when no other product code fits the label order.'
      }
    ]
  },
  {
    url: 'label/pid-2086',
    title: 'Specialty',
    subtitle: 'Label Stock Roll - Healthcare - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Roll', prevStep: 'label/pid-2025',
    products: [
      {
        id: 2185,
        name: 'Wrist Band',
        image: 'label/labels_tags/new/98-400.png',
        tips: 'Any label construction that results in a wristband die design.'
      },
      {
        id: 2186,
        name: 'Tapes (Non Packaging)',
        image: 'label/labels_tags/new/98-351.png',
        tips: 'Tapes are similar to linerless label but are defined by their end use as a package sealing solution.'
      },
      {
        id: 2187,
        name: 'Linerless',
        image: 'label/labels_tags/new/98-350.png',
        tips: 'Linerless labels are pressure sensitive labels that do not have a release liner and are used to provide information. They are similar to tape but are not used to seal packages.'
      },
      {
        id: 2188,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/98-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2189,
        name: 'RFID',
        image: 'label/labels_tags/new/98-370.png',
        tips: 'Any label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2190,
        name: 'Misc. Label Other',
        image: 'label/labels_tags/new/70-999.png',
        tips: 'For use when no other product code fits the label order.'
      }
    ]
  },
  {
    url: 'label/pid-2089',
    title: 'Specialty',
    subtitle: 'Label Stock Cut Sheet - Healthcare - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Cutsheet', prevStep: 'label/pid-2026',
    products: [
      {
        id: 2191,
        name: 'Wrist Band',
        image: 'label/labels_tags/new/97-400.png',
        tips: 'Any label construction that results in a wristband die design.'
      },
      {
        id: 2192,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/97-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2193,
        name: 'RFID',
        image: 'label/labels_tags/new/97-370.png',
        tips: 'Any label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2194,
        name: 'Misc. Label Other',
        image: 'label/labels_tags/new/70-999.png',
        tips: 'For use when no other product code fits the label order.'
      }
    ]
  },
  {
    url: 'label/pid-2092',
    title: 'Specialty',
    subtitle: 'Label Stock Fanfold - Healthcare - Specialty (Blank or Press Printed).',
    category: '/label',
    prev: 'Fanfold', prevStep: 'label/pid-2027',
    products: [
      {
        id: 2195,
        name: 'Wrist Band',
        image: 'label/labels_tags/new/99-400.png',
        tips: 'Any label construction that results in a wristband die design.'
      },
      {
        id: 2196,
        name: 'Dual Web (Dual Face, Integrated, and Glue & PS Overlap - Matchweb)',
        image: 'label/labels_tags/new/99-340.png',
        tips: 'Any label construction other than affixed that requires two different materials. This might be a form/label or different label materials. There are several methods for integrating these different form/label materials.'
      },
      {
        id: 2197,
        name: 'RFID',
        image: 'label/labels_tags/new/99-370.png',
        tips: 'Any label construction that includes a RFID inlay as part of the specifications.'
      },
      {
        id: 2198,
        name: 'Misc. Label Other',
        image: 'label/labels_tags/new/70-999.png',
        tips: 'For use when no other product code fits the label order.'
      }
    ]
  },



  /* Distribution Services */
  {
    url: 'distribution',
    title: 'Distribution Services',
    subtitle: 'Distribution, cold chain or label item.',
    category: '/distribution',
    prev: 'Categories', prevStep: 'guide',
    products: [
      { 
        id: 301, 
        name: 'Navitor Patterson Dental', 
        image: 'distribution/dental-checkup.svg',
        tips: 'Navitor Patterson Dental category.' 
      },
      { id: 302, 
        name: 'Cold Chain Product', 
        image: 'distribution/supply.svg',
        tips: 'Cold Chain Product category.' 
      },
      { id: 303, 
        name: 'Service Provided by Distribution', 
        image: 'distribution/logistics.svg',
        tips: 'Service Provided by Distribution category.' 
      }
    ]
  },
  {
    url: 'distribution/pid-301',
    title: 'Navitor Patterson Dental',
    subtitle: 'Navitor Patterson Dental category.',
    category: '/distribution',
    prev: 'Distribution Services', prevStep: 'distribution',
    products: [
      { 
        id: 304, 
        name: 'Booklets/Manuals', 
        image: 'distribution/dental/brochures.svg',
        tips: 'Booklets/Manuals product.' 
      },
      { 
        id: 305, 
        name: 'Register Forms & Accesories', 
        image: 'distribution/dental/checklist.svg',
        tips: 'Register Forms & Accesories product.' 
      },
      { 
        id: 306, 
        name: 'Business Cards', 
        image: 'distribution/dental/business-card.svg',
        tips: 'Business Cards product.' 
      },
      { 
        id: 307, 
        name: 'Booklets, Manuals/Commercial', 
        image: 'distribution/dental/brochure.svg',
        tips: 'Booklets, Manuals/Commercial Print product.' 
      },
      { 
        id: 308, 
        name: 'Marketing/Sales Collateral', 
        image: 'distribution/dental/marketing.svg',
        tips: 'Marketing/Sales Collateral product.' 
      },
      { 
        id: 309, 
        name: 'Custom Envelopes', 
        image: 'distribution/dental/computer.svg',
        tips: 'Custom Envelopes product.' 
      },
      { 
        id: 310, 
        name: 'Stock Envelopes', 
        image: 'distribution/dental/mail.svg',
        tips: 'Stock Envelopes product.' 
      },
      { 
        id: 311, 
        name: 'Continuous (Unsecure)', 
        image: 'distribution/dental/cycle.svg',
        tips: 'Continuous (Unsecure) product.' 
      },
      { 
        id: 312, 
        name: 'Cut Sheet (Unsecure)', 
        image: 'distribution/dental/papers.svg',
        tips: 'Cut Sheet (Unsecure) product.' 
      },
      { 
        id: 313, 
        name: 'Unit Set (Unsecure)', 
        image: 'distribution/dental/rules.svg',
        tips: 'Unit Set (Unsecure) product.' 
      },
      { 
        id: 314, 
        name: 'Flat (Secure)', 
        image: 'distribution/dental/envelope.svg',
        tips: 'Flat (Secure) product.' 
      },
      { 
        id: 315, 
        name: 'Flat (Unsecure)', 
        image: 'distribution/dental/letter.svg',
        tips: 'Flat (Unsecure) product.' 
      },
      { 
        id: 316, 
        name: 'Custom Labels', 
        image: 'distribution/dental/shopping.svg',
        tips: 'Custom Labels product.' 
      },
      { 
        id: 317, 
        name: 'Stock Labels', 
        image: 'distribution/dental/product-development.svg',
        tips: 'Stock Labels product.' 
      },
      { 
        id: 318, 
        name: 'Office Supplies/Non-Paper', 
        image: 'distribution/dental/medical.svg',
        tips: 'Office Supplies/Non-Paper product.' 
      },
      { 
        id: 319, 
        name: 'Office Supplies/Paper', 
        image: 'distribution/dental/document.svg',
        tips: 'Office Supplies/Paper product.' 
      },
      { 
        id: 320, 
        name: 'Promotional Products Gen Mer', 
        image: 'distribution/dental/loudspeaker.svg',
        tips: 'Promotional Products Gen Mer product.' 
      },
      { 
        id: 321, 
        name: 'Services', 
        image: 'distribution/dental/consult.svg',
        tips: 'Services product.' 
      },
      { 
        id: 322, 
        name: 'Preassembled Kits', 
        image: 'distribution/dental/dental-checkup.svg',
        tips: 'Preassembled Kits product.' 
      },
      { 
        id: 323, 
        name: 'Special Charges Misc', 
        image: 'distribution/dental/salary.svg',
        tips: 'Special Charges Misc product.' 
      },
      { 
        id: 324, 
        name: 'Adhesive & Glue', 
        image: 'distribution/dental/adhesive-tape.svg',
        tips: 'Adhesive & Glue product.' 
      },
      { 
        id: 325, 
        name: 'Art Pencils', 
        image: 'distribution/dental/pencil.svg',
        tips: 'Art Pencils product.' 
      },
      { 
        id: 326, 
        name: 'Binders', 
        image: 'distribution/dental/file.svg',
        tips: 'Binders product.' 
      },
      { 
        id: 327, 
        name: 'Binding Systems & Supplies', 
        image: 'distribution/dental/folder.svg',
        tips: 'Binding Systems & Supplies product.' 
      },
      { 
        id: 328, 
        name: 'Book/Show Cases', 
        image: 'distribution/dental/bookshelf.svg',
        tips: 'Book/Show Cases product.' 
      },
      { 
        id: 329, 
        name: 'Books', 
        image: 'distribution/dental/book.svg',
        tips: 'Books product.' 
      },
      { 
        id: 330, 
        name: 'Business Cases', 
        image: 'distribution/dental/business.svg',
        tips: 'Business Cases product.' 
      },
      { 
        id: 331, 
        name: 'CD/DVD/Media', 
        image: 'distribution/dental/music.svg',
        tips: 'CD/DVD/Media product.' 
      },
      { 
        id: 332, 
        name: 'Clipboards', 
        image: 'distribution/dental/clipboard.svg',
        tips: 'Clipboards product.' 
      },
      { 
        id: 333, 
        name: 'Copy & Multi-use Paper', 
        image: 'distribution/dental/files.svg',
        tips: 'Copy & Multi-use Paper product.' 
      },
      { 
        id: 334, 
        name: 'Desk Accessories', 
        image: 'distribution/dental/workspace.svg',
        tips: 'Desk Accessories product.' 
      },
      { 
        id: 335, 
        name: 'Drawing Pads/Paper & Access.', 
        image: 'distribution/dental/drawing-board.svg',
        tips: 'Drawing Pads/Paper & Access product.' 
      },
      { 
        id: 336, 
        name: 'File Folder Guides', 
        image: 'distribution/dental/file-folder.svg',
        tips: 'File Folder Guides product.' 
      },
      { 
        id: 337, 
        name: 'File Folders', 
        image: 'distribution/dental/folders.svg',
        tips: 'File Folders product.' 
      },
      { 
        id: 338, 
        name: 'Filing Accessories & Storage', 
        image: 'distribution/dental/stock.svg',
        tips: 'Filing Accessories & Storage product.' 
      },
      { 
        id: 339, 
        name: 'Forms', 
        image: 'distribution/dental/chat.svg',
        tips: 'Forms product.' 
      },
      { 
        id: 340, 
        name: 'Indexing Flags & Tabs', 
        image: 'distribution/dental/index.svg',
        tips: 'Indexing Flags & Tabs product.' 
      },
      { 
        id: 341, 
        name: 'Keyboard Accesories', 
        image: 'distribution/dental/keyboard.svg',
        tips: 'Keyboard Accesories product.' 
      },
      { 
        id: 342, 
        name: 'Label Markers & Supplies', 
        image: 'distribution/dental/label.svg',
        tips: 'Label Markers & Supplies product.' 
      },
      { 
        id: 343, 
        name: 'Magnetic Boards & Accessories', 
        image: 'distribution/dental/board.svg',
        tips: 'Magnetic Boards & Accessories product.' 
      },
      { 
        id: 344, 
        name: 'Medical/Healthcare',
        image: 'distribution/dental/doctor.svg',
        tips: 'Medical/Healthcare product.' 
      },
      { 
        id: 345, 
        name: 'Paper Fasteners/Clips/Clamps', 
        image: 'distribution/dental/clip.svg',
        tips: 'Paper Fasteners/Clips/Clamps product.' 
      },
      { 
        id: 346, 
        name: 'Magnetic Boards & Access.', 
        image: 'distribution/dental/schedule.svg',
        tips: 'Magnetic Boards & Accessories product.' 
      },
      { 
        id: 347, 
        name: 'Pencils', 
        image: 'distribution/dental/pencils.svg',
        tips: 'Pencils product.' 
      },
      { 
        id: 348, 
        name: 'Presentation Boards & Acces.', 
        image: 'distribution/dental/presentation.svg',
        tips: 'Presentation Boards & Accessories product.' 
      },
      { 
        id: 349, 
        name: 'Restroom Supplies', 
        image: 'distribution/dental/toilet.svg',
        tips: 'Restroom Supplies product.' 
      },
      { 
        id: 350, 
        name: 'Stickers', 
        image: 'distribution/dental/happy.svg',
        tips: 'Stickers product.' 
      },
      { 
        id: 351, 
        name: 'Flexible Packaging (Shrink)', 
        image: 'distribution/dental/package.svg',
        tips: 'Flexible Packaging (Shrink) product.'
      },
      { 
        id: 352, 
        name: 'Folding Containers', 
        image: 'distribution/dental/packages.svg',
        tips: 'Folding Containers product.' 
      },
      { 
        id: 353, 
        name: 'Plastic Containers', 
        image: 'distribution/dental/container.svg',
        tips: 'Plastic Containers product.' 
      }
    ]
  },
  {
    url: 'distribution/pid-302',
    title: 'Cold Chain Product',
    subtitle: 'Cold Chain Product category.',
    category: '/distribution',
    prev: 'Distribution Services', prevStep: 'distribution',
    products: [
      { 
        id: 354, 
        name: 'Cold Chain Cooler', 
        image: 'distribution/cold/cooler.svg',
        tips: 'Cold Chain Cooler category.' 
      },
      { 
        id: 355, 
        name: 'Cold Chain Gel Pack', 
        image: 'distribution/cold/cold.svg',
        tips: 'Cold Chain Gel Pack category.' 
      },
      { 
        id: 356,
        name: 'Cold Chain Packaging', 
        image: 'distribution/cold/beef.svg',
        tips: 'Cold Chain Packaging category.' 
      },
      { 
        id: 357, 
        name: 'Cold Chain Bag', 
        image: 'distribution/cold/gift-bag.svg',
        tips: 'Cold Chain Bag category.' 
      },
      { 
        id: 358, 
        name: 'Cold Chain Ice', 
        image: 'distribution/cold/ice-cube.svg',
        tips: 'Cold Chain Ice category.' 
      }
    ]
  },
  {
    url: 'distribution/pid-303',
    title: 'Service Provided by Distribution',
    subtitle: 'Service Provided by Distribution category.',
    category: '/distribution',
    prev: 'Distribution Services', prevStep: 'distribution',
    products: [
      { 
        id: 359, 
        name: 'Storage Item ', 
        image: 'distribution/service/storage.svg',
        tips: 'Specifically setup for Overage Storage.' 
      },
      { 
        id: 360, 
        name: 'Monthly or Regular Storage',
        image: 'distribution/service/warehouse.svg', 
        tips: 'Monthly or Regular Storage category.' 
      }
    ]
  }
]

export default routes